import { styled, theme } from '@clickcease/cc-client-components-lib'
import FederatedContext from '../botMitigation/moduleFederation/FederatedContext'
import type {
  GetDomainsResponse,
  PlansDetailsType,
  UserProfileResponse,
  AccountLogoResponse,
} from '../botMitigation/types/federatedContext'
import React from 'react'

interface FederatedProps {
  useGetDomains: () => { data?: GetDomainsResponse }
  useGetPlansDetails: () => PlansDetailsType
  useGetUserProfile: () => { data: UserProfileResponse }
  useGetAccountLogo: () => AccountLogoResponse
}

export const BotzappingWrapperStyled = styled(
  FederatedContext as React.ComponentType<FederatedProps>,
  {
    '& > div': {
      '--base-color': theme.colors.primaryColor.value,
      '--main-white': theme.colors.white.value,
      padding: 0,
      backgroundColor: '$offWhite',
      '.rdt_TableHeadRow, .rdt_Pagination, .rdt_TableRow': {
        backgroundColor: theme.colors.white.value,
      },
    },
  }
)
